"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTSL001_List = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const OpenTable_1 = require("../../base/layout/OpenTable");
const action_1 = require("../../menu/action");
const RegistButton_1 = require("../RegistButton");
exports.DSTSL001_List = react_1.default.memo(({ defaultOpen, isResource, isTeacher, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const handlerButtonClick = () => {
        dispatch((0, action_1.updateMenu)(isResource ? 'learningSupportRoom' : 'notice', {
            menu: isResource ? 'resource' : 'notice',
            detail: 'regist',
        }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OpenTable_1.OpenTable, { isResource: isResource, isTeacher: isTeacher, defaultOpen: defaultOpen }),
        isTeacher && react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick })));
});
